import React, {useContext} from 'react';
import {Grid} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import {
    defaultBreakPoints, defaultFieldLabelStyle,
    defaultHelperTextStyle,
    defaultInputStyle,
    defaultTextAreaCharCount,
    defaultTextAreaRowSize
} from "../utils";
import PhoneNumberInput from "../InputTypes/PhoneNumberInput";
import AllergyRadio from "../InputTypes/AllergyRadio";
import BooleanInput from "../InputTypes/BooleanInput";
import DrugNameNDCRadio from '../InputTypes/DrugNameNDCRadio';
import DatePickerInput from "../InputTypes/DatePickerInput";
import AutoCompleteInput from "../InputTypes/AutoCompleteInput";
import DropZoneInput from "../InputTypes/DropZoneInput";
import TextAreaInput from "../InputTypes/TextAreaInput";
import SelectBox from "../InputTypes/SelectBox";
import CompoundTable from "../InputTypes/CompoundTable";
import FileList from "../../../FileList";
import useStyles from "./styles";
import AppContext from '../../../../contexts/App/App.context'

export default function FormFieldValue(props) {
    const {
        field,
        fieldConfig: {
            fieldInputBreakpoints, type, validations, inputProps, fieldLabelStyle, units,
            render, options: selectOptions, selectSize, maxDate, defaultValue
        },
        fields,
        onBlur,
        onChange,
        handleNumberChange,
        setBanner
    } = props;
    const classes = useStyles();
    const appContext = useContext(AppContext)

    if (type === 'header' || type === 'info') {
        return <></>;
    }

    const {value, errors, isValid, isDirty} = fields[field];
    const select = fields[field] && selectOptions && selectOptions.length > 0 ? selectOptions : fields[field].options
    const error = isDirty && !isValid;
    const helperText = (error && errors && errors.length > 0 && errors[0]) || '';
    const inputBreakPoints = {...defaultBreakPoints.input, ...fieldInputBreakpoints};
    const iProps = {
        ...inputProps,
        type,
        error,
        helperText,
        name: field,
        onBlur,
        onChange,
        value: value || defaultValue || '',
        FormHelperTextProps: {style: defaultHelperTextStyle}
    }
    const labelStyle = {...defaultFieldLabelStyle, ...fieldLabelStyle};
    const textFieldProps = {
        ...inputProps,
        onBlur,
        error,
        helperText,
        label: 'Drug Name',
        FormHelperTextProps: {style: defaultHelperTextStyle}
    }

    const components = {
        allergyRadio: () => <AllergyRadio {...iProps} margin="dense"/>,
        boolean: () => <BooleanInput {...iProps} margin="dense"/>,
        drugNameNDCRadio: () => <DrugNameNDCRadio {...iProps} margin="dense"/>,
        compoundTable: () => <CompoundTable
                                onChange={onChange}
                                errors={errors}
                                compounds={fields.compounds.value}
                                compoundIngredientCount={fields.compoundIngredientCount.value}
                            />,
        drugList: () => <AutoCompleteInput
                            tProps={textFieldProps}
                            value={value}
                            name={field}
                            onChange={(e) => onChange(e, true, type)}
                            type='autocomplete'
                        />,
        ndcInput: () => <TextField
                            variant="outlined"
                            style={{width: '31ch'}} {...iProps}
                            onChange={onChange}
                            id={`${field}_input`}
                            inputProps={{...inputProps, 'autocomplete': 'off', 'inputMode': 'numeric', 'pattern': '[0-9]*'}}
                            margin="dense"
                            type='text'
                            FormHelperTextProps={{style: {width: "35ch"}}}
                        />,
        npiInput: () => <TextField
                            variant="outlined"
                            style={defaultInputStyle} {...iProps}
                            onChange={onChange}
                            id={`${field}_input`}
                            inputProps={{...inputProps, 'autocomplete': 'off', 'inputMode': 'numeric', 'pattern': '[0-9]*'}}
                            margin="dense"
                            type='text'
                            error={!!fields[field]?.error}
                            helperText={fields[field]?.error}
                            FormHelperTextProps={{style: {width: "35ch", color: "#a32d24"}}}
                        />,
        ndcResult: () => <div style={{...labelStyle}} value={value} name={field}>{value}</div>,
        number: () => <TextField
                        variant="outlined"
                        style={defaultInputStyle} {...iProps}
                        onChange={handleNumberChange}
                        id={`${field}_input`}
                        inputProps={{...inputProps, 'autocomplete': 'off'}}
                        margin="dense"
                        type='text'
                    />,
        phone: () => <PhoneNumberInput
                        tProps={{ ...iProps,
                                    variant: 'outlined',
                                    margin: 'dense',
                                    id: `${field}_input`
                                }}
                    />,
        prefilled: () => <div style={{...labelStyle}}>{render ? render(fields, appContext) : value}</div>,
        select: () => <SelectBox
                        id={`${field}_input`} value={value}
                        style={defaultInputStyle} {...iProps}
                        onChange={(e) => onChange(e, true, type)}
                        options={select}
                        name={field} maxHeight={selectSize} type='select'
                    />,
        text: () => <TextField
                        variant="outlined"
                        style={defaultInputStyle} {...iProps}
                        onChange={onChange}
                        id={`${field}_input`}
                        inputProps={{...inputProps, 'autocomplete': 'off'}}
                        margin="dense"
                        type='text'
                    />,
        textarea: () => <TextAreaInput
                            id={`${field}_input`}
                            iProps={iProps}
                            rows={defaultTextAreaRowSize}
                            field={field}
                            maxLength={defaultTextAreaCharCount}
                            type='text'
                        />,
        additionalInfo: () => <TextAreaInput
                            id={`${field}_input`}
                            iProps={iProps}
                            rows={defaultTextAreaRowSize}
                            field={field}
                            maxLength={2000}
                            type='text'
                        />,
        upload: () => <DropZoneInput
                        onChange={onChange}
                        name={field}
                        setBanner={setBanner}
                        attachments={value}
                    />,
        uploadList: () => <FileList files={fields.attachments.value}/>,
        date: () => <DatePickerInput
                        value={value}
                        maxDate={maxDate}
                        name={field}
                        onChange={(e) => onChange(e, true)}
                        validations={validations}
                        error={error}
                        helperText={helperText}
                        FormHelperTextProps={{style: defaultHelperTextStyle}}
                        iProps={iProps}
                    />
    }

    return (
        <Grid item {...inputBreakPoints} className={classes.container}>
            {!type && components.text()}
            {components[type] && components[type]()}
            {units && <div className={classes.unit}>{units}</div>}
        </Grid>
    );
};
